import { FocusEventHandler, useState } from "react"
import { ButtonGroup, Dropdown, Form } from "react-bootstrap"

interface IItemSelect<T> {
	placeholder?: string
	required?: boolean
	items: T[]
	convert?: (item: T) => Item
	valueId?: string
	onChange: (value?: T) => void
	onBlur?: FocusEventHandler
	isInvalid?: boolean
}
/** Only one of value and valueId should be used. */
const ItemSelect = <T,>({
	placeholder,
	required,
	items,
	convert = defaultConvert,
	valueId,
	onChange,
	onBlur,
	isInvalid,
}: IItemSelect<T>) => {
	// get the value and convertedValue from the valueId
	const value = items.find((item) => convert(item).id === valueId)
	const convertedValue = value && convert(value)
	const setValueId = (id: string) => onChange(items.find((e) => convert(e).id === id))
	// handle filtering
	const [filterString, setFilterString] = useState("")
	const filteredItems = items
		.map((item) => convert(item))
		.filter((item) => {
			for (const filter of filterString.split(" ")) {
				if (!item.name.toLowerCase().includes(filter.toLowerCase())) return false
			}
			return true
		})
	//
	return (
		<>
			<Dropdown as={ButtonGroup} onToggle={() => setFilterString("")} style={{ width: "100%" }}>
				<Dropdown.Toggle
					variant=""
					style={{
						border: "var(--bs-border-width) solid var(--bs-border-color)",
						textAlign: "left",
						borderColor: isInvalid ? "#dc3545" : undefined,
						color: isInvalid ? "#dc3545" : undefined,
					}}>
					{convertedValue?.name || placeholder}
				</Dropdown.Toggle>
				<Dropdown.Menu style={{ width: "100%", overflowY: "auto", maxHeight: "50vh", paddingTop: 0 }} onBlur={onBlur}>
					<Form.Control
						type="input"
						value={filterString}
						placeholder="Filter..."
						autoFocus
						onChange={(event) => setFilterString(event.target.value)}
					/>
					{!required && (
						<Dropdown.Item as="button" key={"null"} onClick={() => onChange(undefined)}>
							None
						</Dropdown.Item>
					)}
					{filteredItems.map((item) => (
						<Dropdown.Item as="button" key={item.id} onClick={() => setValueId(item.id)}>
							{item.name}
						</Dropdown.Item>
					))}
				</Dropdown.Menu>
			</Dropdown>
			<Form.Control isInvalid={isInvalid} hidden />
		</>
	)
}
export default ItemSelect

const defaultConvert = (item: any) => item

interface Item {
	id: string
	name: string
}
